import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export const themeV2 = {
  colors: {
    black: unifiedPlatformColorPalette.black,
    inmarketGreen: unifiedPlatformColorPalette.inmarketGreen,
    beaconGreen: '#84D828',
    metricBlue: '#121E33',
    commandBlue: '#243E66',
    magnetBlue: '#4591C7',
    leadBlue: '#AED7F4',
    frameworkGray: '#F5F6F8',
    white: unifiedPlatformColorPalette.white,
  },
  charSpacing: {
    tight: -1.5,
    loose: 3,
    veryLoose: 6,
  },
  fontSizes: {
    h1: 36,
    h2: 18,
    h3: 16,
    content: 14,
  },
};
